import { isAxiosError } from 'axios'

import client from './chowly'
import { PartnerQueryParams } from './partners'

type ConfigParams = {
  params?: Partial<PartnerQueryParams>
  timeout?: number
  headers?: object
}

export const retryGetRequest = async (
  url: string,
  config: ConfigParams,
  retries = 0,
  maxRetries = 3,
) => {
  config = {
    ...config,
    headers: {
      'Timeout-Retries': retries,
    },
  }

  try {
    const { data } = await client.get(url, config)

    return data
  } catch (error) {
    if (isAxiosError(error) && error?.code === 'ECONNABORTED') {
      retries++
      if (retries < maxRetries) {
        await retryGetRequest(url, config, retries)
      }
    }
  }
  return null
}

/**
 * Calculates the duration in seconds between two ISO timestamps.
 * Returns undefined if timestamps are missing or invalid.
 */
export const calculateDurationInSeconds = (
  start: string | null | undefined,
  end: string | null | undefined
): number | undefined => {
  if (!start || !end) return undefined

  const startTime = new Date(start).getTime()
  const endTime = new Date(end).getTime()

  if (isNaN(startTime) || isNaN(endTime)) return undefined

  return Math.floor((endTime - startTime) / 1000)
}